// src/auth/flags.js
// Enable with: REACT_APP_AUTH_ENABLED=true
export const AUTH_ENABLED =
  String(process.env.REACT_APP_AUTH_ENABLED || '').toLowerCase() === 'true';

// Disable with: REACT_APP_SUBSCRIPTION_REQUIRED=false
// Defaults to true (subscription required)
export const SUBSCRIPTION_REQUIRED =
  String(process.env.REACT_APP_SUBSCRIPTION_REQUIRED || 'true').toLowerCase() !== 'false';